import { ErrorLogComponent } from '@cian/error-log-component';
import { ReliabilityDetails } from '@cian/frontend-newbuilding-reliability-widget';
import { EscrowDescription } from '@cian/frontend-newbuilding-reliability-widget/es/components/EscrowDescription';
import { ReliabilityDesktop } from '@cian/frontend-newbuilding-reliability-widget/es/components/ReliabilityDesktop';
import { NewbuildingReliabilityContext } from '@cian/frontend-newbuilding-reliability-widget/es/shared/context/NewbuildingReliabilityContext';
import {
  EReliabilityStatus,
  IReliabilityDetail,
} from '@cian/frontend-newbuilding-reliability-widget/es/types/reliability';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectIsNewbuildingReliabilityEnabled } from 'shared/selectors/abExperiments';
import { newbuildingReliabilitySelector } from 'shared/selectors/newbuildingReliability';

import { getNewbuildingHouseId, getNewbuildingId } from '../../selectors/newbuilding';

const DOM_RF_LINK = 'https://наш.дом.рф';

export const ReliabilityContainer = () => {
  const { httpApi, logger } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId);
  const houseId = useSelector(getNewbuildingHouseId);
  const reliability = useSelector(newbuildingReliabilitySelector);
  const reliabilityEnabled = useSelector(selectIsNewbuildingReliabilityEnabled);
  const [isDetaisOpen, setIsDetailsOpen] = React.useState<boolean>(false);
  const [isEscrowOpen, setEscrowOpen] = React.useState<boolean>(false);

  const closeDetails = React.useCallback(() => setIsDetailsOpen(false), [setIsDetailsOpen]);
  const openDetails = React.useCallback(() => setIsDetailsOpen(true), [setIsDetailsOpen]);

  const closeEscrow = React.useCallback(() => setEscrowOpen(false), [setEscrowOpen]);
  const openEscrow = React.useCallback(() => setEscrowOpen(true), [setEscrowOpen]);

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  if (!reliability || !reliabilityEnabled) {
    return null;
  }

  return (
    <div data-testid="reliablev2" id="reliable">
      <ErrorLogComponent logger={logger}>
        <CardSectionNew>
          <ReliabilityDesktop
            title={reliability.checkStatus.title}
            status={reliability.checkStatus.status as unknown as EReliabilityStatus}
            date={reliability.checkStatus.date}
            details={reliability.details as unknown as IReliabilityDetail[]}
            domrfLink={DOM_RF_LINK}
            onEscrowButtonClick={openEscrow}
            onDetailsButtonClick={openDetails}
            actions={reliability.actions}
          />
        </CardSectionNew>
        <NewbuildingReliabilityContext.Provider value={contextValue}>
          <ReliabilityDetails
            onClose={closeDetails}
            open={isDetaisOpen}
            onEscrowIconClick={openEscrow}
            houseId={houseId}
            newbuildingId={newbuildingId}
          />
        </NewbuildingReliabilityContext.Provider>

        <EscrowDescription onClose={closeEscrow} isOpen={isEscrowOpen} />
      </ErrorLogComponent>
    </div>
  );
};
